import "./inc/retail_user.js";
import { qsa, pad, initNavOffset } from "./inc/dom.js";
import {
    HOT,
    COLD,
    isTouchMap,
    getCounties,
    getDesignCenters,
    buildDcInfo,
    buildCountyInfo,
    createMap,
    createInfoWindow,
    createCountyPolygon,
    createDcMarker,
    assignDcToCounty,
    loadGoogleMaps,
} from "./inc/wwb_map.js";
import { Fancybox } from "@fancyapps/ui";
import * as bootstrap from "bootstrap";
// oilib.js needs bootstrap to be available on the window object. It uses bootstrap popovers (maybe others, too).
window.bootstrap = bootstrap;

import Swiper from 'swiper/bundle';
window.Swiper = Swiper;

var triggerTabList = [].slice.call(document.querySelectorAll(".tab-btn"));

triggerTabList.forEach(function (triggerEl) {
  var tabTrigger = new bootstrap.Tab(triggerEl);
  var hash = '#' + triggerEl.href.split("#")[1];
  var tabBtn = document.querySelector( hash + "-tab");

  triggerEl.addEventListener("click", function (event) {
    event.preventDefault();
    tabBtn.click();
  })
})


const onNavScroll = () => {
    document.body.classList.toggle("nav-scrolled", window.scrollY > 20);
};
window.addEventListener("scroll", onNavScroll, { passive: true });
onNavScroll();



const panzoom = document.querySelector(".panzoom");
const panzoom_reset = document.querySelector(".panzoom-reset");
const panZoomImg = document.querySelector('.panzoom__content');
const fpImgLink = document.querySelectorAll("[data-imgurl]");

if (panzoom) {
    const myPanzoom = new Panzoom(panzoom, {
        minScale:0.5,
        maxScale:3,
    });
    panzoom_reset.addEventListener("click", function (event) {
        myPanzoom.zoomTo(1);
    })
}

for (const link of fpImgLink) {
    link.addEventListener('click', function () {
        fpImgLink.forEach((e)=> {e.classList.remove('active-bg')})
        link.classList.add('active-bg');
        var imgUrl = link.dataset.imgurl;
        console.log(imgUrl);
        panZoomImg.src = imgUrl;
    });
}


/*
 * FANCYBOX
 *
 * The new Fancybox v4 (non-jQuery) triggers a "done" event for up to three images when
 * the carousel is first initilaized. To avoid triggering 3 image view events on every
 * Fancybox initCarousel action, an imageview event is triggered on the initCarousel
 * event, but "done" events are then ignored for 1 second. After 1 second, image view
 * events will be triggered as typical.
 */

let fancyboxEventBlock = false

/** Abstracted event action handler
 * @param {import("@fancyapps/ui").Fancybox} fancybox
 */
const doFancyboxOiEvent = (fancybox) => {
    if (fancybox.options.trigger.dataset.oiEventName) {
        let oi_event_name = fancybox.options.trigger.dataset.oiEventName;
        if ("undefined" != typeof window.dataLayer) {
            window.dataLayer.push({ event: oi_event_name });
        }
        if ("undefined" != typeof window.hfaDataLayer) {
            window.hfaDataLayer.push({ event: oi_event_name });
        }
    }
}

Fancybox.bind("[data-fancybox]", {
    on: {
        initCarousel: (fancybox) => {
            if(!fancyboxEventBlock) {
                fancyboxEventBlock = true

                doFancyboxOiEvent(fancybox)

                setTimeout(() => {
                    fancyboxEventBlock = false
                }, 1000)
            }
        },
        done: (fancybox, slide) => {
            if(!fancyboxEventBlock) {
                doFancyboxOiEvent(fancybox)
            }
        },
        destroy: () => {
            fancyboxEventBlock = false
        },
    },
});

/* END FANCYBOX */


// This fires the oi.utils function that will wrap all iframes contained in WYSIWYG
// editors with appropriate oi-aspect classes.

window.addEventListener('load', function () {
  oi.utils.wrap_oi_aspect();
}, false);

const initMobileDrawer = () => {
    const hamburger = document.getElementById("hamburger");
    const drawer = document.getElementById("drawer");
    if (!hamburger || !drawer) return;
    const overlay = document.getElementById("drawer-overlay");
    const closeBtn = document.getElementById("drawer-close");
    const open = () => {
        document.dispatchEvent(new CustomEvent("oi:drawer-open", { detail: { source: "nav" } }));
        drawer.classList.add("open");
        hamburger.setAttribute("aria-expanded", "true");
        document.body.style.overflow = "hidden";
    };
    const close = () => {
        drawer.classList.remove("open");
        hamburger.setAttribute("aria-expanded", "false");
        document.body.style.overflow = "";
    };
    hamburger.addEventListener("click", open);
    if (closeBtn) closeBtn.addEventListener("click", close);
    if (overlay) overlay.addEventListener("click", close);
    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape" && drawer.classList.contains("open")) close();
    });
    document.addEventListener("oi:drawer-open", (e) => {
        if (e.detail && e.detail.source !== "nav" && drawer.classList.contains("open")) close();
    });
    drawer.querySelectorAll(".mobile-nav-toggle").forEach((toggle) => {
        toggle.addEventListener("click", () => {
            const submenu = toggle.nextElementSibling;
            const isOpen = toggle.getAttribute("aria-expanded") === "true";
            toggle.setAttribute("aria-expanded", String(!isOpen));
            if (submenu) submenu.classList.toggle("open", !isOpen);
        });
    });
};

const initFeaturedSwipers = () => {
    if (!window.Swiper) return;
    qsa(".content-block--featured").forEach((block) => {
        const el = block.querySelector(".featured-swiper");
        if (!el) return;
        new window.Swiper(el, {
            slidesPerView: 1,
            spaceBetween: 0,
            navigation: {
                prevEl: block.querySelector(".featured-prev"),
                nextEl: block.querySelector(".featured-next"),
            },
            pagination: {
                el: block.querySelector(".fc-count"),
                type: "fraction",
                formatFractionCurrent: (n) => (n < 10 ? "0" + n : n),
                formatFractionTotal: (n) => (n < 10 ? "0" + n : n),
            },
        });
    });
};

const initBleedSliders = () => {
    if (!window.Swiper) return;
    qsa("[data-bleed-slider]").forEach((scope) => {
        const track = scope.querySelector("[data-bleed-slider-track]");
        if (!track || track.dataset.bleedSliderReady) return;
        track.dataset.bleedSliderReady = "true";

        const prev = scope.querySelector("[data-overlay-prev]");
        const next = scope.querySelector("[data-overlay-next]");
        const pagination = scope.querySelector("[data-overlay-pagination]");
        const current = scope.querySelector("[data-overlay-current]");
        const total = scope.querySelector("[data-overlay-total]");
        const pagePrev = scope.querySelector("[data-overlay-page-prev]");
        const pageNext = scope.querySelector("[data-overlay-page-next]");
        const formatCount = (value) => (value < 10 ? `0${value}` : `${value}`);

        const perView = (key, fallback) => {
            const value = parseFloat(scope.dataset[key]);
            return Number.isNaN(value) ? fallback : value;
        };

        const edgeOffset = () => {
            if (!scope.dataset.bleedFull) return 0;
            const value = parseFloat(getComputedStyle(scope).marginLeft);
            return Number.isNaN(value) ? 0 : Math.abs(value);
        };

        const swiper = new window.Swiper(track, {
            slidesOffsetBefore: edgeOffset(),
            slidesOffsetAfter: 0,
            slidesPerView: perView("bleedXs", 1),
            slidesPerGroup: 1,
            spaceBetween: 14,
            grabCursor: true,
            watchOverflow: true,
            breakpoints: {
                768: { slidesPerView: perView("bleedSm", 2.2), spaceBetween: 18 },
                1024: { slidesPerView: perView("bleedMd", 3.2), spaceBetween: 20 },
                1200: { slidesPerView: perView("bleedLg", 4.5), spaceBetween: 20 },
                1600: { slidesPerView: perView("bleedXl", perView("bleedLg", 4.5)), spaceBetween: 20 },
            },
        });

        const pageStep = () => {
            const visible = swiper.params.slidesPerView;
            return Math.max(1, Math.floor(typeof visible === "number" ? visible : 1));
        };
        const pageCount = () =>
            swiper.isLocked
                ? 1
                : Math.max(1, Math.ceil(swiper.slides.length / pageStep()));
        const currentPage = () => {
            if (swiper.isEnd) return pageCount() - 1;
            return Math.min(pageCount() - 1, Math.floor(swiper.activeIndex / pageStep()));
        };
        const goToPage = (target) => {
            const pages = pageCount();
            if (target < 0 || target >= pages) return;
            swiper.slideTo(Math.min(target * pageStep(), swiper.slides.length - 1));
        };

        const render = () => {
            const pages = pageCount();
            const page = currentPage();
            const single = pages < 2;
            if (current) current.textContent = formatCount(page + 1);
            if (total) total.textContent = formatCount(pages);
            if (pagination) pagination.hidden = single;
            if (prev) {
                prev.hidden = single;
                prev.disabled = swiper.isBeginning;
                prev.classList.toggle("is-disabled", swiper.isBeginning);
            }
            if (next) {
                next.hidden = single;
                next.disabled = swiper.isEnd;
                next.classList.toggle("is-disabled", swiper.isEnd);
            }
            if (pagePrev) pagePrev.disabled = page <= 0;
            if (pageNext) pageNext.disabled = page >= pages - 1;
        };

        if (prev) prev.addEventListener("click", () => swiper.slidePrev());
        if (next) next.addEventListener("click", () => swiper.slideNext());
        if (pagePrev) {
            pagePrev.addEventListener("click", () => goToPage(currentPage() - 1));
        }
        if (pageNext) {
            pageNext.addEventListener("click", () => goToPage(currentPage() + 1));
        }

        swiper.on("slideChange", render);
        swiper.on("reachBeginning", render);
        swiper.on("reachEnd", render);
        swiper.on("breakpoint", render);
        swiper.on("resize", () => {
            if (scope.dataset.bleedFull) {
                swiper.params.slidesOffsetBefore = edgeOffset();
                swiper.update();
            }
            render();
        });
        render();
    });
};

const initTestimonials = () => {
    if (!window.Swiper) return;
    const el = document.querySelector(".testimonials-swiper");
    if (!el) return;
    new window.Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: { prevEl: ".test-prev", nextEl: ".test-next" },
        pagination: {
            el: ".test-count",
            type: "fraction",
            formatFractionCurrent: (n) => (n < 10 ? "0" + n : n),
            formatFractionTotal: (n) => (n < 10 ? "0" + n : n),
        },
    });
};

const initTilsonLive = () => {
    const track = document.querySelector(".tl-carousel");
    if (!track) return;
    const cards = qsa(".tl-card", track);
    if (!cards.length) return;
    const currentEl = document.querySelector(".tl-current");
    const totalEl = document.querySelector(".tl-total");
    const prev = document.querySelector("[data-tl-prev]");
    const next = document.querySelector("[data-tl-next]");
    const controls = document.querySelector(".tl-pagination");
    const step = () => {
        const s = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : cards[0].offsetWidth;
        return s > 0 ? s : cards[0].offsetWidth || 1;
    };
    const maxScroll = () => track.scrollWidth - track.clientWidth;
    const pages = () => Math.max(1, Math.round(maxScroll() / step()) + 1);
    const update = () => {
        const total = pages();
        const i = Math.min(Math.max(Math.round(track.scrollLeft / step()) + 1, 1), total);
        if (currentEl) currentEl.textContent = pad(i);
        if (totalEl) totalEl.textContent = pad(total);
        if (controls) controls.hidden = total < 2;
        if (prev) prev.disabled = track.scrollLeft <= 1;
        if (next) next.disabled = track.scrollLeft >= maxScroll() - 1;
    };
    track.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update, { passive: true });
    update();
    if (prev) prev.addEventListener("click", () => track.scrollBy({ left: -step(), behavior: "smooth" }));
    if (next) next.addEventListener("click", () => track.scrollBy({ left: step(), behavior: "smooth" }));
};

const initWwbMap = () => {
    const el = document.getElementById("wwb-map");
    if (!el) return;
    const counties = getCounties();
    const map = createMap(el, {
        draggable: false,
        disableDoubleClickZoom: true,
        keyboardShortcuts: false,
        gestureHandling: "none",
    });
    const infowindow = createInfoWindow({ disableAutoPan: true });
    const bounds = new google.maps.LatLngBounds();
    const polygonByName = {};

    counties.forEach((county) => {
        if (!county.border || !county.border.length) return;
        if (county.lat == null || county.lng == null) return;
        const entry = createCountyPolygon(map, county, bounds);
        const polygon = entry.polygon;
        polygon.addListener("mouseover", () => {
            polygon.setOptions(HOT);
            infowindow.setContent(buildCountyInfo(entry.county, entry.designCenters));
            infowindow.setPosition(entry.center);
            infowindow.open(map);
        });
        polygon.addListener("mouseout", () => {
            polygon.setOptions(COLD);
            infowindow.close();
        });
        polygon.addListener("click", () => {
            if (isTouchMap()) {
                infowindow.setContent(buildCountyInfo(entry.county, entry.designCenters));
                infowindow.setPosition(entry.center);
                infowindow.open(map);
            } else if (county.permalink) {
                window.location.href = county.permalink;
            }
        });
        polygonByName[county.name] = entry;
    });

    getDesignCenters().forEach((dc) => {
        if (dc.lat == null || dc.lng == null) return;
        const pos = new google.maps.LatLng(dc.lat, dc.lng);
        new google.maps.Marker({
            position: pos,
            map,
            clickable: false,
            zIndex: 998,
            icon: { path: google.maps.SymbolPath.CIRCLE, scale: 13, fillColor: "#000000", fillOpacity: 0.16, strokeWeight: 0 },
        });
        const marker = createDcMarker(map, pos, dc);
        const containing = assignDcToCounty(pos, dc, polygonByName);
        marker.addListener("mouseover", () => {
            infowindow.setContent(containing ? buildCountyInfo(containing.county, containing.designCenters) : buildDcInfo(dc));
            infowindow.setPosition(pos);
            infowindow.open(map);
        });
        marker.addListener("mouseout", () => {
            infowindow.close();
        });
        marker.addListener("click", () => {
            if (isTouchMap()) {
                infowindow.setContent(containing ? buildCountyInfo(containing.county, containing.designCenters) : buildDcInfo(dc));
                infowindow.setPosition(pos);
                infowindow.open(map);
            } else if (dc.permalink) {
                window.location.href = dc.permalink;
            }
        });
        bounds.extend(pos);
    });

    if (!bounds.isEmpty()) map.fitBounds(bounds, { top: 48, right: 32, bottom: 48, left: 32 });
};
window.initWwbMap = initWwbMap;

const loadWwbMap = () => {
    const el = document.getElementById("wwb-map");
    if (!el) return;
    loadGoogleMaps("wwb-gmaps-js", "initWwbMap", initWwbMap);
};

const initWwbLazyLoad = () => {
    const el = document.getElementById("wwb-map");
    if (!el) return;
    if (!("IntersectionObserver" in window)) {
        loadWwbMap();
        return;
    }
    const io = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            loadWwbMap();
            obs.disconnect();
        });
    }, { rootMargin: "300px 0px" });
    io.observe(el);
};

const initPlanCardGalleries = (scope) => {
    if (!window.Swiper) return;
    qsa(".plan-card-swiper", scope || document).forEach((el) => {
        if (el.dataset.swiperInit) return;
        const card = el.closest(".plan-card");
        if (!card) return;
        el.dataset.swiperInit = "1";
        const prev = card.querySelector(".plan-card-prev");
        const next = card.querySelector(".plan-card-next");
        [prev, next].forEach((btn) => {
            if (!btn) return;
            btn.addEventListener("click", (e) => {
                e.preventDefault();
                e.stopPropagation();
            });
        });
        new window.Swiper(el, {
            slidesPerView: 1,
            nested: true,
            watchOverflow: true,
            navigation: { prevEl: prev, nextEl: next },
        });
    });
};

initNavOffset();
initMobileDrawer();
initFeaturedSwipers();
initBleedSliders();
initTestimonials();
initTilsonLive();
window.initPlanCardGalleries = initPlanCardGalleries;
initPlanCardGalleries();
initWwbLazyLoad();
